import React from 'react';

import {StepConfigUISchemaWithTabsV2, isTabbedUISchema} from '../StepConfigEditorTypes';
import StepConfigEditorRouterV2, {StepConfigEditorRouterV2Props} from './StepConfigEditorRouterV2';
import StepConfigFormTabContainer, {StepConfigFormTabContainerProps} from './StepConfigFormTabContainer';

type StepConfigFormProps = {
  uiSchema: StepConfigUISchemaWithTabsV2;
  clientStateId: string;
} & (Omit<StepConfigEditorRouterV2Props, 'uiSchema'> | Omit<StepConfigFormTabContainerProps, 'uiSchema'>); // Typescript has a hard time combining the uiSchema prop

export default function StepConfigForm(props: StepConfigFormProps): JSX.Element {
  if (isTabbedUISchema(props.uiSchema)) {
    return (
      <StepConfigFormTabContainer {...props} clientStateId={props.clientStateId} uiSchema={props.uiSchema} />
    );
  }

  return <StepConfigEditorRouterV2 {...props} uiSchema={props.uiSchema} />;
}
